<script setup lang="ts">
import { getBackgroundColor, getInitials } from '@/utils'

withDefaults(
  defineProps<{
    user: { displayName: string; email: string }
    avatarSize?: 'large' | 'normal' | 'xlarge'
    textSize?: 'small' | 'normal'
    tooltip?: boolean
    showEmail?: boolean
  }>(),
  {
    avatarSize: 'normal',
    textSize: 'normal',
    showEmail: true,
  },
)
</script>

<template>
  <div
    class="grid auto-cols-min grid-flow-col items-center gap-x-2"
    :class="{ 'grid-rows-2': showEmail }"
    v-bind="$attrs"
  >
    <Avatar
      shape="circle"
      class="text-white"
      :class="{ 'row-span-2': showEmail }"
      :size="avatarSize"
      :label="getInitials(user.displayName)"
      :style="{
        backgroundColor: getBackgroundColor(user.displayName),
      }"
    />
    <h3
      v-tooltip.top="tooltip ? { value: user?.displayName, autoHide: false } : ''"
      :class="{ 'text-sm': textSize === 'small', 'font-normal': !showEmail }"
      class="text-nowrap"
    >
      {{ user?.displayName }}
    </h3>
    <p
      v-if="showEmail"
      v-tooltip.top="tooltip ? { value: user?.email, autoHide: false } : ''"
      :class="{ 'text-xs': textSize === 'small' }"
    >
      {{ user?.email }}
    </p>
  </div>
</template>
